import React from "react";
import { STATUS_META } from "@/lib/api";

export default function StatusBadge({ status, size = "sm", testid }) {
  const m = STATUS_META[status] || STATUS_META.testing;
  const sz = size === "lg" ? "px-3 py-1 text-[11px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={testid || `status-${status}`}
      className={`${sz} mono uppercase tracking-widest rounded-sm inline-flex items-center gap-1.5 border`}
      style={{ color: m.color, background: m.bg, borderColor: m.border }}
    >
      <span className="w-1 h-1 rounded-full" style={{ background: m.color }} />
      {m.label}
    </span>
  );
}
